import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, AbstractControl, ValidationErrors } from '@angular/forms';

import { EmptySelectionTaxonomy } from '../../../taxonomy.constants';
import { TaxonomyService } from '../../../../../services/taxonomy.service';

@Component({
  selector: 'intent-form',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './intent-form.component.html',
  styleUrl: './intent-form.component.scss',
})
export class IntentFormComponent {
  constructor(
    private formBuilder: FormBuilder,
    public taxonomyService: TaxonomyService
  ) {
    this.intentForm = this.formBuilder.group({
      label: ['', [Validators.required, this.noWhitespaceValidator]],
      description: [''],
    });
  }

  @Input() selectedTaxonomyItem: any = { ...EmptySelectionTaxonomy };
  @Input() editId: number | undefined;
  @Output() onIntentFormClose = new EventEmitter<void>();
  @Output() onIntentFormComplete = new EventEmitter<void>();

  intentForm: FormGroup;

  ngOnInit() {
    if (this.editId != undefined && this.taxonomyService.selectedEnitity?.LinkedEntities) {
      const intent = this.taxonomyService.selectedEnitity?.LinkedEntities[this.editId];
      this.intentForm.patchValue({
        label: intent.label,
        description: intent.description,
      });
    }
  }

  // Custom validator to prevent label with only whitespaces
  noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    return !isWhitespace ? null : { whitespace: true };
  }

  handleCancelIntent() {
    this.onIntentFormClose.emit();
  }

  handleAddIntent() {
    const trimmedLabel = this.intentForm.value.label?.trim();
    const trimmedDescription = this.intentForm.value.description?.trim() || '';

    if (!trimmedLabel) {
      this.intentForm.get('label')?.setErrors({ whitespace: true });
      return;
    }

    const intentData = {
      label: trimmedLabel,
      description: trimmedDescription,
    };

    if (this.editId != undefined && this.taxonomyService.selectedEnitity?.LinkedEntities) {
      this.taxonomyService.selectedEnitity.LinkedEntities[this.editId] = { ...intentData };
    } else {
      const previousIntents = this.taxonomyService.selectedEnitity?.LinkedEntities ?? [];
      const tempIntents = [...previousIntents, intentData];
      this.taxonomyService.selectedEnitity.LinkedEntities = tempIntents;
    }

    this.onIntentFormComplete.emit();
  }
}
